import { MergeTags } from '../constants/merge-tags';

export const isNullOrUndefined = <T>(val: T): boolean => {
  return val === null || val === undefined;
};

export const isNullOrEmpty = <T>(items: T[]): boolean => {
  return isNullOrUndefined(items) || items.length === 0;
};

export const isNullOrWhiteSpace = (value: string | null | undefined): boolean => {
  return isNullOrUndefined(value) || value!.trim() === '';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const replaceMergeTags = (value: string | null | undefined, selectedParticipant: any): string => {
  if (isNullOrWhiteSpace(value)) {
    return '';
  }

  value = value!.replaceAll(MergeTags.FIRST_NAME, selectedParticipant.firstName ?? '');
  value = value!.replaceAll(MergeTags.LAST_NAME, selectedParticipant.lastName ?? '');
  value = value!.replaceAll(MergeTags.JOB_TITLE, selectedParticipant.jobTitle ?? '');
  value = value!.replaceAll(MergeTags.COMPANY_NAME, selectedParticipant.companyName ?? '');
  value = value!.replaceAll(MergeTags.EMAIL, selectedParticipant.email ?? '');
  value = value!.replaceAll(MergeTags.BOOTH_LOCATION, selectedParticipant.boothLocation ?? '');
  value = value!.replaceAll(MergeTags.SESSION_TITLE, selectedParticipant.sessionTitle ?? '');
  value = value!.replaceAll(MergeTags.BUZZWAVE_ID, selectedParticipant.campaignParticipantId ?? '');
  value = value!.replaceAll(MergeTags.EXTERNAL_ID, selectedParticipant.externalId ?? '');

  return value;
};
